























































































































import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISelectItem } from "@/types";
import {
  IPartner,
  IPartnerCreateRequest,
  IPartnerUpdateRequest
} from "@/types/partner";
import { ICategoryListRequest } from "@/types/category";
import CategoryForm from "./CategoryForm.vue";

@Component({
  components: { CategoryForm }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("partner/adminGet")
  public getPartner!: (id: number) => void;

  @Action("category/adminGetList")
  public getCategoryList!: (params: ICategoryListRequest) => boolean;

  @Action("partner/adminCreate")
  public create!: (params: IPartnerCreateRequest) => boolean;

  @Action("partner/adminUpdate")
  public update!: (data: {
    partner_id: number;
    params: IPartnerUpdateRequest;
  }) => boolean;

  @Action("partner/adminDelete")
  public delete!: (partner_id: number) => boolean;

  @Action("partner/adminIsDeletable")
  public partnerIsDeletable!: (partner_id: number) => boolean;

  @Getter("partner/canDelete")
  public deletable!: boolean;

  @Getter("partner/single")
  public partner!: IPartner;

  @Getter("category/selectItem")
  public categoryList!: ISelectItem[];

  @Mutation("category/clear")
  public clear!: () => void;

  public partner_id = 0;

  public valid = true;
  public lazy = false;
  public dialog = false;
  public categoryDialog = false;

  public rules = {
    name: [
      (v: string) => !!v || "外注先名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "外注先名は30文字以下で入力してください"
    ],
    kana: [
      (v: string) => !!v || "フリガナは必須です",
      (v: string) =>
        (v && v.length <= 60) || "フリガナは60文字以下で入力してください",
      (v: string) =>
        /^[\u30A1-\u30FC]+$/.test(v) ||
        "フリガナは全角カタカナで入力してください"
    ],
    cutoff_at: [
      // (v: string) =>
      //   /^[1-9]+[0-9]*$/.test(v)|| "締め日は半角数字で入力してください",
      (v: number) =>
        (1 <= v && v <= 31) ||
        !v ||
        "締め日は半角数字で1以上31以下を入力してください"
    ]
  };

  public params: IPartnerCreateRequest = {
    name: "",
    kana: "",
    tel: "",
    staff: "",
    cutoff_at: "",
    categories: []
  };

  //--------
  // コンポーネント作成時実行
  public async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    this.clear();

    await this.getCategoryList({ per_page: 0 });

    // 更新
    if (this.partner_id) {
      await Promise.all([
        this.getPartner(this.partner_id),
        this.partnerIsDeletable(this.partner_id)
      ]);
      this.setDefault();
    }
  }

  //--------
  // 更新時デフォルト値をセットする
  private setDefault() {
    this.params.name = this.partner.name;
    this.params.kana = this.partner.kana;
    this.params.tel = this.partner.tel;
    this.params.staff = this.partner.staff;
    this.params.cutoff_at = this.partner.cutoff_at;
    if (this.partner.categories) {
      this.partner.categories.forEach(category => {
        this.params.categories.push(category.id);
      });
    }
  }

  //--------
  // 確定ボタンが押された際の挙動
  // 更新時と作成時で問合せ先が違う
  public async submit() {
    let result = false;
    if (this.partner_id) {
      result = await this.update({
        partner_id: this.partner_id,
        params: this.params
      });
    } else {
      result = await this.create(this.params);
    }
    if (result) {
      this.$router.go(-1);
    }
  }

  //--------
  // 削除確認画面
  public destroyConfirm() {
    this.dialog = true;
  }

  //--------
  // 削除実行
  public async destroy() {
    this.dialog = false;
    if (await this.delete(this.partner_id)) {
      this.$router.go(-2);
    }
  }

  public async categoryCreated() {
    await this.getCategoryList({ per_page: 0 });
    this.categoryDialog = false;
  }
}
